export const productImages = {};

export const homePageDealerCodes = ['1010N3783', '1010N3739', '1010N3705', '@1010N3768', '1010N3705'];

const data = {
  title: 'Shifting Focus',
  model: 'Rolex',
  description: "Patek Philippe Watches chronograph steel / gold automatic men's watch 116503 ",
  price: 230140,
  tegTypes: ['check_outline', 'hot_outline'],
  imgUrl: '/img/card_img.png',
};

export const alsoLikes = [data, data, data, data, data, data];

export interface IDescription {
  title: string;
  value: string;
}

export interface IAboutDescription {
  id?: string;
  key: string;
  value: string;
}

export interface ITitle {
  id?: string;
  title: string;
  description: IAboutDescription[];
}

export interface IAbout {
  title: string;
  data: ITitle[];
}

export const info = {
  description: {
    title: 'Description',
    value:
      'Pre-Owned Rolex GMT-Master II "Pepsi" (116719BLRO) self-winding automatic watch, features a 40mm 18k white gold case with a red and blue "Pepsi" Cerachrom bezel surrounding a blue dial on an 18k white gold Oyster bracelet with folding buckle. Functions include hours, minutes, seconds, date and GMT. \n' +
      '\n' +
      'This watch comes complete with box and papers. Scattered Serial. Time remaining on the factory warranty!',
  },
  about: [
    {
      title: 'Features',
      data: [
        {
          id: '1',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '2',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '3',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '4',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
      ],
    },
    {
      title: 'TBD (about the brand)',
      data: [
        {
          id: '1',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '2',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '3',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '4',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
      ],
    },
    {
      title: 'TBD',
      data: [
        {
          id: '1',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code ',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '2',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '3',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
        {
          id: '4',
          title: 'Title',
          description: [
            {
              id: '1',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '2',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '3',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '4',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '5',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '6',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '7',
              key: 'Listing code',
              value: 'CZ69E5',
            },
            {
              id: '8',
              key: 'Listing code',
              value: 'CZ69E5',
            },
          ],
        },
      ],
    },
  ],
  documents: {
    title: 'Documents',
    description: [
      {
        value: 'Warranty card.pdf',
      },
      {
        value: 'Warranty card.pdf',
      },
    ],
  },
};
